import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-mask-password',
  templateUrl: './mask-password.component.html',
  styleUrls: ['./mask-password.component.scss']
})
export class MaskPasswordComponent implements OnInit, OnChanges {
  @Input() form_group: UntypedFormGroup;
  @Input() form_control;
  @Input() label;
  @Input() placeholder;
  @Input() mandatory;
  @Input() design_pattern;
  @Input() minLength;
  @Input() maxLength;
  @Input() maxValue;
  @Input() minValue;
  @Input() pattern;
  @Input() floatLabel = 'always';
  @Input() validationScript;
  @Input() mismatch_data;
  @Input() enable_mismatch;
  @Input() label_overflow;
  @Input() appearance;

  form: UntypedFormGroup = new UntypedFormGroup({
    pass: new UntypedFormControl(null)
  })
  actualPassword = [];
  temperoryPassword;
  currentCursorPosition = 0;
  passwordChar = '•';
  hide: boolean;
  constructor() { }

  ngOnInit(): void {
    console.log(this.form_group.get([this.form_control]).markAllAsTouched())
    this.form.controls.pass.valueChanges.subscribe(res => {
      let a: string = res;
      this.temperoryPassword = a;
      var passwordLength = this.temperoryPassword.length;
      for (var i = 0; i < passwordLength; i++) {
        if (this.temperoryPassword[i] != this.passwordChar && this.temperoryPassword[i] != 'empty') {
          this.actualPassword[i] = this.temperoryPassword[i];
        }
      }
      // Get current cursor position.
      // currentCursorPosition = this.selectionStart;
      let input: any = document.getElementById('tallite_mask_input_fields');
      this.currentCursorPosition = input.selectionStart;
      if (!a || !a.length) {
        this.actualPassword = []
      }

    })
  }
  ngOnChanges(ev: SimpleChanges): void {
    if (ev && ev.validationScript) {
      this.validationScript = ev.validationScript.currentValue;
      if (this.form_group && this.form_control && typeof this.validationScript == "object") {
        this.setValidators(this.validationScript, this.form, 'pass');
      }
    }
    if (ev && ev.mismatch_data) {
      this.mismatch_data = ev.mismatch_data.currentValue;
    }
  }
  passKeyup(event) {
    console.log(event)
    this.hide = false
    if (this.temperoryPassword) {
      var passwordLength = this.temperoryPassword.length;

      if (passwordLength < this.actualPassword.length) {

        var difference = this.actualPassword.length - passwordLength,
          key = event.keyCode || event.charCode;

        // Check if last keypress was backspace or delete
        if (key == 8 || key == 46) {
          this.actualPassword.splice(this.currentCursorPosition, difference);
        }
        // User highlighted and overwrite part of the password
        else {
          this.actualPassword.splice(this.currentCursorPosition - 1, difference + 1);
          this.actualPassword.splice(this.currentCursorPosition - 1, 0, this.temperoryPassword[this.currentCursorPosition - 1]);
        }

      }
      else if (!passwordLength) {
        this.actualPassword = []
        this.form_group.get(this.form_control).patchValue(null);
        console.log(this.form_group.get([this.form_control]).value)
      }
      if (this.form_group) {
        try {
          this.form_group.get([this.form_control]).patchValue(this.actualPassword.join(''));
          console.log(this.form_group.get([this.form_control]).value)
        }
        catch (err) {
          console.log(err)
        }
      }
      setTimeout(() => {
        this.temperoryPassword = this.temperoryPassword.replace(/./g, this.passwordChar);
        this.form.controls.pass.patchValue(this.temperoryPassword);
        if (this.enable_mismatch && this.mismatch_data) {
          if (this.form_group.get([this.form_control]).value != this.mismatch_data) {
            setTimeout(() => {
              this.form.controls.pass.setErrors({ notEqual: true })
              console.log(this.form.controls.pass.errors)
            })
          }
          else {
            this.form.controls.pass.setErrors(null)
          }
        }
      })
    }


    // document.getElementById('jaksdjkasjkdjskajdksajdksjakdjsakjdksajdkasjd').value=this.value.replace(/(.)/g,'•');
  }
  setValidators(field, form, controlName) {
    try {
      // form.get(field.title).setValidators([Validators.required, Validators.minLength(field.minLength), Validators.maxLength(field.maxLength), Validators.pattern(field.pattern), Validators.min(field.min), Validators.max(field.max)])

      let validators = [];
      //Min and Max length validation

      if (field.minLength != '' && field.minLength != null) {
        validators.push(Validators.minLength(eval(field.minLength)));
        this.minLength = eval(field.minLength);
      }

      if (field.maxLength != '' && field.maxLength != null) {
        validators.push(Validators.maxLength(eval(field.maxLength)));
        this.maxLength = eval(field.maxLength);
      }

      if (field.pattern && field.pattern != '') {
        validators.push(Validators.pattern(field.pattern));
        this.pattern = field.pattern;

      }

      //Min and Max value validation

      if (field.min != '' && field.min != null) {
        validators.push(Validators.min(eval(field.min)));
        this.minValue = eval(field.min)
      }

      if (field.max != '' && field.max != null) {
        validators.push(Validators.max(eval(field.max)));
        this.maxValue = eval(field.max)
      }

      if (field.mandatory != '' && field.mandatory) {
        validators.push(Validators.required);
        this.mandatory = field.mandatory
      }

      form.get(controlName).setValidators(validators);
      form.get(controlName).updateValueAndValidity();
    }
    catch (err) { }
  }

}
